// extracted by mini-css-extract-plugin
export default {"container":"Xs-z","heading":"Ys-z","text":"Zs-z","info":"_s-z","link":"at-z","fullMaxWidth":"bt-z"};